import { render, staticRenderFns } from "./teamImport.vue?vue&type=template&id=2510c496"
import script from "./teamImport.vue?vue&type=script&lang=js"
export * from "./teamImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports